module.exports = {
  request: ($stateParams, Api) ->
    return Api.ResearchRequest.get(id:$stateParams.supportId).$promise

  messages: ($stateParams, Api) ->
    return Api.ResearchRequestMessage.query(request:$stateParams.supportId).$promise
}
